function Hero() {
  return (
    <div className="bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl p-6 mb-6 shadow-lg">
      <h1 className="text-3xl font-bold mb-2">Milestone Funding DAO</h1>
      <p className="opacity-90">
        Fund projects transparently and release payments only when milestones are approved.
      </p>
    </div>
  );
}

export default Hero;
